import gql from "graphql-tag";

export const budgetFragment = gql`
  fragment BudgetFragment on Budget {
    id
    amount
    approvedAt
  }
`;

export const projectFragment = gql`
  fragment ProjectFragment on Project {
    id
    name
    description
    defaultPaymentOption
    budget {
      ...BudgetFragment
    }
    needsBudgetApproval
    budgetTracking
    plannedTimeTracking
    active
    estimationUnit
    withHourlyRate
    isCowork
    color
    velocity
  }
  ${budgetFragment}
`;

export const projectResourceFragment = gql`
  fragment ProjectResourceFragment on ProjectResource {
    id
    link
    type
    label
    tooltip
    category
  }
`;

export const PROJECT_DELIVERY_BUDGET_FRAGMENT = gql`
  fragment ProjectDeliveryBudgetFragment on ProjectDeliveryBudget {
    projectId
    commercialBudgetAmount
    totalOfferedAmount
    allocatedAmount
    effectiveAllocatedAmount
    toAllocateAmount
    months {
      id
      projectId
      month
      allocatedAmount
      timesheetAmount
      offeredAmount
      effectiveAmount
      employeeAllocations {
        id
        userId
        projectRoleId
        userName
        roleName
        hourlyRate
        allocatedAmount
        allocatedHours
        timesheetAmount
        timesheetHours
        remainingAmount
      }
    }
  }
`;
